import { createContext } from 'react';

export const ConversationContext = createContext();
